<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12" lg="6" sm="12">
        <v-card>
          <v-list-item>
            <v-list-item-avatar>
                <v-icon>mdi-account-convert</v-icon>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title class="headline">外注作業者情報登録</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
          <v-card-text>
            <v-form ref="subcontractor_form" v-model="valid" @submit.prevent>
              <v-text-field label="氏名" v-model="name" :rules="subcontractorNameRules" dense outlined></v-text-field>
              <v-select label="取引先" v-model="supplier" :rules="suppliersRules" item-text="name" item-value="id" :items="suppliers" no-data-text="データがありません" dense outlined return-object/>
              <v-text-field label="単価" v-model.number="unit_price" :rules="unitPriceRules" dense outlined></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey lighten-1" class="mr-3" :to="{ name: 'SubcontractorMaster' }" depressed>キャンセル</v-btn>
            <v-btn color="success" @click.prevent="checkDialog" :disabled="!valid" depressed>確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <custom-dialog :maxWith="dialogMaxWith" :title="dialogTitle" :items="dialogItems" :drawer="dialogDrawer" visibleStore
        @stored="submit" @canceled="dialogCancel"/>
    </v-row>
  </v-container>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import SubcontractorApi from "@/api/subcontractor-api";
  import CustomDialog from "@/components/custom_ui/CustomDialog";
  import Rule from "@/validation/rules";

  export default {
    name: "CreateSubcontractorMaster",
    components: {
      CustomDialog
    },
    data: () => ({
      loading: false,
      // フォームの項目
      name: '',
      supplier: '',
      unit_price: '',

      // プルダウン項目
      subcontractor_types: '',
      suppliers: '',

      // 登録ダイアログ
      dialogMaxWith: 500,
      dialogTitle: '',
      dialogItems: [],
      dialogDrawer: false,

      // バリデーション
      valid: true,
      subcontractorNameRules: Rule.subcontractorNameRules,
      suppliersRules: Rule.suppliersRules,
      unitPriceRules: Rule.unitPriceRules,
    }),
    created () {
      this.initialize();
    },
    methods: {
      isLoading() {
        this.loading = !this.loading;
        this.$emit("loading", this.loading);
      },
      initialize () {
        this.isLoading();
        this.subcontractorApi = new SubcontractorApi();
        this.id = "0";
        const promise = this.subcontractorApi.info(this.id);
        promise.then((response) => {
          this.suppliers = response.data.body.suppliers_list;
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          if(error.response){
            this.$emit("error",error.response.data.message);
          }else{
            this.$emit("error","サーバーエラーが発生しました。");
          }
        }).finally(() => {
          this.isLoading();
        });
      },
      // 登録ボタン押下時イベント
      checkDialog () {
        this.dialogTitle = '登録しますか？';
        this.dialogItems = [
          { name: '氏名', value: this.name },
          { name: '取引先', value: this.supplier.name },
          { name: '単価', value: this.unit_price },
        ];
        this.dialogDrawer = true;
      },
      dialogCancel() {
        this.dialogDrawer = false;
      },
      // 確認ダイアログの「登録」確定ボタン押下イベント
      submit() {
        if (this.$refs.subcontractor_form.validate()) {
          this.isLoading();
          const params = {
            name: this.name,
            suppliers_id: this.supplier.id,
            unit_price: this.unit_price,
          };
          const promise = this.subcontractorApi.store(params);
          promise.then((response) => {
              this.$router.push({ name: 'SubcontractorMaster' });
              this.$emit('success', response.data.message);
          }).catch(error => {
            useAppInsights().trackException({exception: error});
            if(error.response){
              this.$emit("error",error.response.data.message);
            }else{
              this.$emit("error","サーバーエラーが発生しました。");
            }
          }).finally(() => {});
          this.isLoading();
        }
      }
    },
  };
</script>
